var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_648_33617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6666 30C9.58705 30 7.59269 29.2098 6.12223 27.8033C4.65178 26.3968 3.82568 24.4891 3.82568 22.5C3.82568 20.5109 4.65178 18.6032 6.12223 17.1967C7.59269 15.7902 9.58705 15 11.6666 15C12.1577 12.812 13.5945 10.8891 15.6609 9.65452C16.6841 9.04321 17.831 8.61925 19.0362 8.40685C20.2414 8.19446 21.4813 8.1978 22.6851 8.41667C23.8889 8.63554 25.033 9.06566 26.0521 9.68247C27.0712 10.2993 27.9453 11.0907 28.6245 12.0115C29.3038 12.9324 29.7748 13.9646 30.0108 15.0493C30.2468 16.134 30.2431 17.2499 29.9999 18.3333H31.6666C33.2137 18.3333 34.6974 18.9479 35.7914 20.0419C36.8853 21.1358 37.4999 22.6196 37.4999 24.1667C37.4999 25.7138 36.8853 27.1975 35.7914 28.2915C34.6974 29.3854 33.2137 30 31.6666 30H29.9999",
    stroke: "#202842",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 25L20 20L25 25",
    stroke: "#202842",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20 20V35",
    stroke: "#202842",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_648_33617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.26e8a744ad149967daba28e9f52eb116.svg";
export { ForwardRef as ReactComponent };